import { Component, HostBinding, Input } from '@angular/core'

@Component({
	selector: 'add-icon',
	template: `
		<svg
			xmlns="http://www.w3.org/2000/svg"
			[attr.width]="size"
			viewBox="0 0 24 24"
			[attr.stroke-width]="stroke"
			stroke="currentColor"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			<path d="M12 5l0 14"></path>
			<path d="M5 12l14 0"></path>
		</svg>
	`,
	styles: [
		`
			:host {
				display: inline-block;
			}
		`,
	],
	standalone: true,
})
export class AddIconComponent {
	@Input() size: number = 18
	@Input() stroke: 1 | 1.25 | 1.5 | 1.75 | 2 = 2

	@HostBinding('style.height') get height() {
		return `${this.size}px`
	}
	@HostBinding('style.width') get width() {
		return `${this.size}px`
	}
}
